import { isGraphPointer } from 'is-graph-pointer';
import { sh } from '@tpluscode/rdf-ns-builders/loose';
import { SubselectExpression } from './SubselectExpression.js';
export class DistinctExpression extends SubselectExpression {
    static match(pointer) {
        return isGraphPointer(pointer.out(sh.distinct));
    }
    static fromPointer(pointer, factory) {
        const distinct = factory.nodeExpression(pointer.out(sh.distinct));
        return new DistinctExpression(pointer.term, distinct);
    }
    get requiresFullContext() {
        return this.distinct.requiresFullContext;
    }
    get rootIsFocusNode() {
        return this.distinct.rootIsFocusNode;
    }
    constructor(term, distinct) {
        super(term, distinct);
        this.distinct = distinct;
    }
    _applySubselectClause(select) {
        return {
            ...select,
            distinct: true,
        };
    }
}
